module.exports = __webpack_public_path__ + "static/media/pildistamise_keeld.74e2b862.svg";